import { GEGSystemType } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const GEGConfigurationTypeToPhraseKey: EnumDictionary<GEGSystemType, string> = {
    [GEGSystemType.New]: 'GEG_RECOMMENDATION.CONFIGURATION_TYPE.NEW',
    [GEGSystemType.Current]: 'GEG_RECOMMENDATION.CONFIGURATION_TYPE.CURRENT',
    [GEGSystemType.Hybrid]: 'GEG_RECOMMENDATION.CONFIGURATION_TYPE.HYBRID'
};
